import axios from "axios"
import {identityApiUrl} from "../../../config"


const identityApi = axios.create({
    baseURL: identityApiUrl,
})

export {identityApi}